module.exports = __webpack_public_path__ + "img/136.98f08268.svg";